<template>
  <SendByEmailDialog :is-open="isDialogOpened"
                     :cancelDisabled="archivesStore.sendArchivesPending"
                     :okLoading="archivesStore.sendArchivesPending"
                     :title="$t('archives.dialogs.ArchivesListSendByEmailDialog.title')"
                     @cancel="closeDialog"
                     @send="sendArchive"
  />
</template>

<script>
import SendByEmailDialog from '@/common/dialogs/SendByEmailDialog.vue'
import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
import { useArchivesStore } from '@/stores/archivesStore'

export default {
  name: 'ArchivesListSendByEmailDialog',
  components: { SendByEmailDialog },
  mixins: [dialogMixin],
  setup() {
    const archivesStore = useArchivesStore()
    return { archivesStore }
  },
  props: {
    archiveId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    async sendArchive(emailAddresses) {
      if (emailAddresses.length === 0) {
        return
      }

      try {
        await this.archivesStore.sendArchives({
          params: {
            archivesFilesIds: [this.archiveId],
            emails: emailAddresses,
          },
        })

        toast.success(this.$t('archives.dialogs.ArchivesListSendByEmailDialog.sendSuccess'))
        this.closeDialog()
      } catch (error) {
        console.error(error)
        const errorMessage = error.response?.data?.errorCode === 'ERR_INVALID_RIGHTS' ? 'sendInvalidRightsError' : 'sendError'
        toast.error(this.$t(`archives.dialogs.ArchivesListSendByEmailDialog.${errorMessage}`))
      }
    },
  },
}
</script>
